<template>
    <div class="account-edit-modal">
        <TitleBaseBox :title="title" @close="close" @confirm="confirmClick" @cancel="cancelClick">
            <div class="account-info-list" :class="{ 'info-list-en': $i18n.locale != 'cn' }">
                <AddDataPanel :label="nameLabel">
                    <RulesInput
                        :placeholder="inputNameLabel"
                        :initValue="nameData.name"
                        @inputChange="accountChange"
                        :rules="inputRules.userName.rules"
                        :tips="nameData.tips"
                        :disabled="isEdit"
                    />
                </AddDataPanel>
                <AddDataPanel :label="emailLabel">
                    <RulesInput
                        :placeholder="inputEmailLabel"
                        :initValue="emailData.email"
                        @inputChange="emailChange"
                        :rules="inputRules.email.rules"
                        :tips="emailData.tips"
                        :disabled="isExist || isEdit"
                    />
                </AddDataPanel>
                <AddDataPanel :label="characterLabel">
                    <Select class="info-item-input" :initValue="initRoleValue" :options="getRoleOptions" @menuClick="roleChange" />
                </AddDataPanel>
                <AddDataPanel :label="groupLabel" :required="false" v-if="hasGroupRight">
                    <Select class="info-item-input" :initValue="initGroupValue" :options="getGroupOptions" @menuClick="groupChange" />
                </AddDataPanel>
                <AddDataPanel class="add-data-content" :label="maxChatLabel" v-if="hasImRight">
                    <RadioGroup class="checked-radio" :radios="initMaxChatRadios" :space="55" @change="maxChatChange" />
                    <div v-show="maxChatSettings[1].checked">
                        <IconInput class="max-chat-input" :initValue="initMaxChat" @inputChange="maxChatInput" />
                    </div>
                </AddDataPanel>
                <AddDataPanel class="add-data-content" :label="receiveLabel" v-if="hasTicketRight">
                    <RadioGroup class="checked-radio" :radios="initMaxReceRadios" :space="55" @change="maxReceChange" />
                    <div v-show="maxReceSettings[1].checked">
                        <IconInput class="max-chat-input" :initValue="initMaxReceive" @inputChange="maxReceiveInput" />
                    </div>
                </AddDataPanel>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import AddDataPanel from "../AddDataPanel";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import RadioGroup from "@/views/zhiji/bComponents/checks/RadioGroup";
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import RulesInput from "@/views/zhiji/bComponents/inputs/RulesInput";
import { maxChatRadios, receiveChatRadios, inputRules } from "../../personConfig.js";
import { checkAll } from "@/views/zhiji/js/common/inputValidata.js";
import checkAuth, { checkModule } from "@/lib/auth";

export default {
    name: "accountEditModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        AddDataPanel,
        Select,
        RadioGroup,
        IconInput,
        RulesInput,
    },
    data() {
        return {
            initRoleValue: (this.data.addData && this.data.addData.userRole) || "",
            initGroupValue: (this.data.addData && this.data.addData.userGroup) || "all",
            initMaxChat: (this.data.addData && this.data.addData.chatNum) || "",
            initMaxReceive: (this.data.addData && this.data.addData.maxWork) || "",
            maxChatSettings: maxChatRadios(),
            maxReceSettings: receiveChatRadios(),
            nameData: {
                name: (this.data.addData && this.data.addData.userName) || "",
                tips: ""
            },
            emailData: {
                email: (this.data.addData && this.data.addData.account) || "",
                tips: ""
            },
            mid: "",
            isExist: false,
            timer: null
        };
    },
    computed: {
        isEdit() {
            return !!this.data; // 判断是否是编辑，新增的时候传的data是空串
        },
        inputRules() {
            return inputRules();
        },
        nameLabel() {
            return this.$t("zhiji.personnel.accountManage.tabelCloumn.name");
        },
        inputNameLabel() {
            return this.$t("zhiji.personnel.accountManage.accountEditModal.nameTips");
        },
        emailLabel() {
            return this.$t("zhiji.personnel.accountManage.accountEditModal.emailLabel");
        },
        inputEmailLabel() {
            return this.$t("zhiji.personnel.accountManage.accountEditModal.emailTips");
        },
        title() {
            return this.data
                ? this.$t("zhiji.personnel.accountManage.accountEditModal.editAccountLabel")
                : this.$t("zhiji.personnel.accountManage.accountEditModal.addAccountLable");
        },
        characterLabel() {
            return this.$t("zhiji.personnel.accountManage.tabelCloumn.role");
        },
        groupLabel() {
            return this.$t("zhiji.personnel.accountManage.tabelCloumn.group");
        },
        maxChatLabel() {
            return this.$t("zhiji.personnel.accountManage.tabelCloumn.chatMax");
        },
        receiveLabel() {
            return this.$t("zhiji.personnel.accountManage.tabelCloumn.maxWork");
        },
        initMaxChatRadios() {
            this.data.addData && this.data.addData.chatNum
                ? this.setCheckedRadio("custom", this.maxChatSettings)
                : this.setCheckedRadio("default", this.maxChatSettings);

            return this.maxChatSettings;
        },
        initMaxReceRadios() {
            this.data.addData && this.data.addData.maxWork
                ? this.setCheckedRadio("custom", this.maxReceSettings)
                : this.setCheckedRadio("default", this.maxReceSettings);

            return this.maxReceSettings;
        },
        getGroupOptions() {
            let options = [...this.getStorePorp("groupOption")];

            if (!options.length) {
                this.$store.dispatch("zhiji/initGroupOption");
            }

            return options;
        },
        getRoleOptions() {
            let options = [...this.getStorePorp("roleOption")];

            if (!options.length) {
                this.$store.dispatch("zhiji/initRoleOption");
            }

            return options;
        },
        hasRelaterRight() {
            return checkAuth("system.usermanager.relateuser");
        },
        hasGroupRight() {
            return checkModule("ticket") || checkModule("im");
        },
        hasTicketRight() {
            return checkModule("ticket");
        },
        hasImRight() {
            return false;
            // return checkModule("im");
        }
    },
    mounted() {
        this.getOneAccountDetail();
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.personnelManage[propName];
        },
        getOneAccountDetail() {
            this.data &&
                this.zhiji
                    .requestByServiceName("getAccountDetail", {
                        accountId: this.data.rowId,
                        page: 1,
                        size: 10
                    })
                    .then(data => {
                        let accountDetail = data.accountData[0];
                        this.nameData.name = accountDetail.userName;
                        this.emailData.email = accountDetail.account;
                    });
        },
        close() {
            this.$emit("closeModal");
        },
        setCheckedRadio(radioType, radiosData) {
            let all = radiosData[0];
            let custom = radiosData[1];

            all.checked = false;
            custom.checked = false;

            radioType == "custom"
                ? radiosData.splice(1, 1, Object.assign({}, custom, { checked: true }))
                : radiosData.splice(0, 1, Object.assign({}, all, { checked: true }));
        },
        maxChatChange(type) {
            this.setRadiosChecked(type, this.maxChatSettings);
        },
        maxChatInput(data) {
            this.initMaxChat = data;
        },
        maxReceiveInput(data) {
            this.initMaxReceive = data;
        },
        maxReceChange(type) {
            this.setRadiosChecked(type, this.maxReceSettings);
        },
        setRadiosChecked(type, radiosData) {
            let def = radiosData[0];
            let custom = radiosData[1];
            if (type === "default") {
                def.checked = true;
                custom.checked = false;
            } else {
                def.checked = false;
                custom.checked = true;
            }
        },
        roleChange(data) {
            this.initRoleValue = data.value;
        },
        groupChange(data) {
            this.initGroupValue = data.value;
        },
        accountChange(value) {
            clearTimeout(this.timer);
            this.timer = setTimeout(async () => {
                if (value.tips === "success") {
                    this.nameData.name = value.userContact;
                    let res = await this.queryUsers(value.userContact);
                    if (res[0] && res[0].value) {
                        this.mid = res[0].value.mid || "";
                        this.emailData.email = res[0].value.email;
                        this.nameData.tips = '该账号已开通VLink权限，邮箱不可被修改。';
                        this.isExist = true;
                    } else {
                        this.mid = "";
                        this.emailData.email = "";
                        this.nameData.tips = "";
                        this.isExist = false;
                    }
                }
            }, 500);
        },
        emailChange(value) {
            if (value.tips === "success") {
                this.emailData.email = value.userContact;
            }
        },
        cancelClick() {
            this.close();
        },
        confirmClick() {
            this.nameData.tips = checkAll(
                inputRules().userName.rules,
                this.nameData.name
            );
            this.emailData.tips = checkAll(inputRules().email.rules, this.emailData.email);
            let checkedData = {
                roleId: this.initRoleValue,
                maxChat: this.initMaxChat,
                maxReceive: this.initMaxReceive
            };
            // eslint-disable-next-line
            this.checkAccountData(checkedData) ? this.showErrorTips(this.checkAccountData(checkedData))
                : this.saveAccountEdit();
        },
        showErrorTips(errMessage) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "error",
                    message: errMessage
                }
            });
        },
        saveAccountEdit() {
            let requst = {
                accountName: this.nameData.name,
                useEmail: this.emailData.email,
                roleId: this.initRoleValue,
                groups: this.initGroupValue === "all" ? "" : this.initGroupValue,
                onlineMax: this.maxChatSettings[1].checked ? this.initMaxChat : 0,
                dayMax: this.maxReceSettings[1].checked ? this.initMaxReceive : 0,
                memberId: this.mid || "",
            };
            let requstUrl = "";
            if (this.data) {
                requstUrl = "updateAccountEdit";
                requst.accountId = this.data.rowId;
            } else {
                requstUrl = "saveAccountEdit";
            }
            if (this.nameData.tips === "success" && this.emailData.tips === "success") {
                this.zhiji.requestByServiceName(requstUrl, requst).then(ret => {
                    // 错误提示处理
                    if (ret.errMsg) {
                        const reusedTips = this.hasRelaterRight
                            ? this.$t("zhiji.personnel.existTips") + this.$t("zhiji.personnel.existAdmin")
                            : this.$t("zhiji.personnel.existTips");
                        const message = ret.errCode == 50001 ? reusedTips : ret.errMsg;
                        this.$alert(message, this.$t("zhiji.common.tips"), {
                            confirmButtonText: this.$t("zhiji.common.confirm")
                        });
                        return;
                    }
                    this.$store.dispatch("zhiji/queryAccountList", {});
                    this.close();
                });
            }
        },
        checkAccountData(data) {
            if (!data.roleId) {
                return this.$t("zhiji.personnel.roleManage.roleEditModal.selectRoleTip");
            }

            if (!data.maxChat && this.maxChatSettings[1].checked) {
                return this.$t("zhiji.personnel.groupManage.groupEditModal.checkMaxChatTips");
            }

            if (!data.maxReceive && this.maxReceSettings[1].checked) {
                return this.$t("zhiji.personnel.groupManage.groupEditModal.checkMaxWorkTips");
            }
        },
        queryUsers(query) {
            const request = {
                name: query,
                size: 30
            };
            return this.zhiji.requestByServiceName("queryExistedUsers", request).then(ret => {
                return ret.list.map(u => ({
                    value: u,
                    label: u.name,
                    key: u.name
                }));
            });
        },
    }
};
</script>

<style lang="less" scoped>
.account-edit-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .account-info-list {
        font-size: 12px;
        margin-right: 20px;

        .add-data-content {
            height: 40px;

            .max-chat-input {
                width: 80px;
                margin-top: 4px;
                border: 1px solid #d8e4f0;
                border-radius: 4px;
            }
        }

        .info-input {
            width: 100%;
            border: 1px solid #d8e4f0;
        }

        .info-item-input {
            width: 300px;
            border-radius: 4px;
            padding: 4px 8px 5px 8px;
            background: #fff;
            border: solid 1px #d8e4f0;
            box-sizing: border-box;
            margin-right: 0;
            flex: 1;
        }
        .add-input-tip {
            position: absolute;
            top: 40px;
            font-size: 12px;
            line-height: 12px;
            left: 112px;
            white-space: nowrap;
        }
        .show-right-text {
            top: 10px;
            left: 99%;
        }
        .input-tip-error,
        .show-right-text {
            i {
                width: 18px;
                height: 18px;
                display: inline-block;
                vertical-align: -4px;
                background: url("@{zhijiStaticImagePath}class-spr.png");
            }
        }
        .error {
            border-color: #e03838;
        }
        .input-tip-error {
            color: #e03838;

            i {
                background-position: -222px -50px;
            }
        }
        .show-right-text {
            i {
                background-position: -240px -50px;
            }
        }

        .checked-radio {
            position: relative;
            top: 9px;
            margin-right: 5px;
        }
    }

    .info-list-en {
        width: 500px;
    }
}
</style>
